/**
 * Component Registry for Faster Actually Theme
 * 
 * Extends the base test-avenue-universal-package theme registry with Faster Actually specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-test-avenue-universal-package/registry';

/**
 * Faster Actually specific component overrides.
 * These components have been customized for the Faster Actually brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const fasteractuallyOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const fasteractuallyOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Faster Actually properties.
 * Inherits all components from the test-avenue-universal-package theme, with Faster Actually overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...fasteractuallyOverrides,
};

export default registry;
